export default "__VITE_ASSET__DmYWl2Iw__"